import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Button, CircularProgress } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Star as StarIcon } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { users } from '../services/api';

const MAX_ATTEMPTS = 6;
const POLL_INTERVAL_MS = 2000;

const SubscriptionSuccess = () => {
    const navigate = useNavigate();
    const { updateUser } = useAuth();
    const [verifying, setVerifying] = useState(true);
    const attempts = useRef(0);

    useEffect(() => {
        let timeoutId;

        const poll = async () => {
            try {
                const res = await users.getMe();
                if (res.data.tier === 'PREMIUM') {
                    updateUser({ tier: 'PREMIUM' });
                    setVerifying(false);
                    return;
                }
            } catch {
                // network blip — keep polling
            }

            attempts.current += 1;
            if (attempts.current < MAX_ATTEMPTS) {
                timeoutId = setTimeout(poll, POLL_INTERVAL_MS);
            } else {
                // Webhook is taking longer than expected; show success anyway and
                // let the user navigate — the tier will be correct on next login.
                updateUser({ tier: 'PREMIUM' });
                setVerifying(false);
            }
        };

        // Give the webhook a 1.5s head start before first poll
        timeoutId = setTimeout(poll, 1500);
        return () => clearTimeout(timeoutId);
    }, [updateUser]);

    return (
        <Container maxWidth="sm" sx={{ mt: 10, textAlign: 'center' }}>
            <Paper elevation={3} sx={{ p: 6 }}>
                {verifying ? (
                    <>
                        <CircularProgress size={48} sx={{ mb: 3 }} />
                        <Typography variant="h6">Activating your Premium account…</Typography>
                    </>
                ) : (
                    <>
                        <CheckCircleIcon sx={{ fontSize: 72, color: 'success.main', mb: 2 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 2 }}>
                            <StarIcon sx={{ color: '#FFD700' }} />
                            <Typography variant="h4" fontWeight={700}>
                                Welcome to Premium!
                            </Typography>
                            <StarIcon sx={{ color: '#FFD700' }} />
                        </Box>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                            Your subscription is now active. Enjoy unlimited availability slots
                            and all upcoming Premium features.
                        </Typography>
                        <Button variant="contained" size="large" onClick={() => navigate('/availability')}>
                            Set Up Your Availability
                        </Button>
                        <Box sx={{ mt: 2 }}>
                            <Button variant="text" onClick={() => navigate('/dashboard')}>
                                Go to Dashboard
                            </Button>
                        </Box>
                    </>
                )}
            </Paper>
        </Container>
    );
};

export default SubscriptionSuccess;
